import {h, Fragment} from "preact"
import { useState, useEffect } from 'preact/hooks'
import { useAppState } from '@nosto/preact'
import VariantBadge from './VariantBadge'

export default ({ tags1, url, id, name, currentColor }) => {
    const { response: { products }, loading } = useAppState()

    const [variantNum, setVariantNum] = useState(undefined);

    let group = tags1?.find(el => el.toLowerCase().includes("group"));

    const isDev = location.host === "shop-melissa-dev.myshopify.com";
    const isProd = location.host === "www.shopmelissa.com";

    let key;
    
    if (isDev) {
        key = "UCekm2BcKPE2kWlgt5ucGu1imTtocmcEPmN6pqa4vycYKVtJ6T8xueb5Beck9T9D"
    } else if (isProd) {
        key = "m8l3TqfeK27N3AEdw9tfifNdsW3X8JnjFPNu3hyi1U2zfQlVzeNurEbMqwevbJwd"
    }

    //fetch variants
    let query = `query {
        products(filter:{ tags1: "${group}", availability: "InStock" }, limit: 100) {
            products {
                productId
            }
        } 
    }`

    useEffect(() => {
        fetch('https://api.nosto.com/v1/graphql', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/graphql',
                'Authorization': 'Basic ' + btoa(":" + key)
            }),
            mode: 'cors',
            body: query
        })
            .then(res => res.json())
            .then((data) => {
                let variantSize = data?.data?.products?.products?.length;

                if (variantSize > 0) {
                    setVariantNum(variantSize)
                }
            })

    }, [loading])

    return (
        <VariantBadge
            key={`${url}-${id}-${variantNum}`}
            url={url}
            id={id}
            variantNum={variantNum}
            name={name}
            currentColor={currentColor}
        /> 
    )

}